<form class="search-form" [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
  <app-scroll-view class="scroll-view">
    <div class="filter-container">
      <div class="row gx-2">
        <div class="col-md-6">
          <div class="field-set">
            <label label> Estado </label>

            <app-select-box
              formControlName="status"
              [items]="statusList"
              displayExpr="label"
              valueExpr="value"
              [showClearButton]="true"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-set">
            <label label> ID SIIA </label>

            <app-input-box
              formControlName="idSiia"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-set">
            <label label> Referência da entidade </label>

            <app-input-box
              formControlName="refentity"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-set">
            <label label> Designação </label>

            <app-input-box
              formControlName="designation"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>
        </div>

        <div class="col-md-12">
          <div class="field-set">
            <label label> Entidade </label>

            <app-select-box
              formControlName="entityId"
              [items]="entityList"
              displayExpr="name"
              valueExpr="id"
              [searchEnabled]="true"
              [searchCaseSensitiveEnabled]="false"
              [showClearButton]="true"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-set">
            <label label> Data da publicação entre </label>

            <div class="row g-2">
              <div class="col-md-6">
                <app-date-box
                  formControlName="startPublicationDate"
                  type="date"
                  [showClearButton]="false"
                  [showErrorEnabled]="false"
                  [appBlockModalDrag]="!(isMobileModeObservable | async)"
                ></app-date-box>
              </div>

              <div class="col-md-6">
                <app-date-box
                  formControlName="endPublicationDate"
                  type="date"
                  [showClearButton]="false"
                  [showErrorEnabled]="false"
                  [appBlockModalDrag]="!(isMobileModeObservable | async)"
                ></app-date-box>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-set">
            <label label> Data limite de adesão entre </label>

            <div class="row g-2">
              <div class="col-md-6">
                <app-date-box
                  formControlName="startMembershipDeadlineDate"
                  type="date"
                  [showClearButton]="false"
                  [showErrorEnabled]="false"
                  [appBlockModalDrag]="!(isMobileModeObservable | async)"
                ></app-date-box>
              </div>

              <div class="col-md-6">
                <app-date-box
                  formControlName="endMembershipDeadlineDate"
                  type="date"
                  [showClearButton]="false"
                  [showErrorEnabled]="false"
                  [appBlockModalDrag]="!(isMobileModeObservable | async)"
                ></app-date-box>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-set">
            <label label> Em execução entre </label>

            <div class="row g-2">
              <div class="col-md-6">
                <app-date-box
                  formControlName="startExecutionDate"
                  type="date"
                  [showClearButton]="false"
                  [showErrorEnabled]="false"
                  [appBlockModalDrag]="!(isMobileModeObservable | async)"
                ></app-date-box>
              </div>

              <div class="col-md-6">
                <app-date-box
                  formControlName="endExecutionDate"
                  type="date"
                  [showClearButton]="false"
                  [showErrorEnabled]="false"
                  [appBlockModalDrag]="!(isMobileModeObservable | async)"
                ></app-date-box>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="field-set">
            <app-check-box
              formControlName="interestActivated"
              label="Apenas anúncios em que entidade manifestou interesse"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-check-box>
          </div>
        </div>
      </div>
    </div>

    <div class="result-list-container" #resultListContentEl>
      <label> RESULTADO DA PESQUISA </label>

      <app-list class="list" [items]="resultList" [scrollable]="false">
        <ng-template listItem let-item="item">
          <div class="item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
            <div class="actions">
              <div class="btn-item" #btnZoomToEl>
                <app-button
                  [buttonType]="
                    modelZoomToSelected === item ? 'primary' : 'normal'
                  "
                  styleType="text"
                  shapeType="circle"
                  icon="assets/icons/location-arrow.svg"
                  (click)="onBtnZoomToClick(item)"
                  [disabled]="!item.geometry"
                ></app-button>

                <app-tooltip
                  [target]="btnZoomToEl"
                  verticalAlignment="top"
                  horizontalAlignment="center"
                >
                  Ver no mapa
                </app-tooltip>
              </div>
            </div>

            <div class="title">
              {{ item.attributes.description }} -
              {{ item.attributes.designation }}
            </div>
          </div>
        </ng-template>
      </app-list>

      <div class="pagination-container">
        <app-pagination
          [totalCount]="totalCount"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          (pageIndexChange)="onPageChange($event)"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-pagination>
      </div>

      <app-loading-panel
        [visible]="loadingController.changes | async"
        [container]="resultListContentEl"
        [overlayMask]="false"
      ></app-loading-panel>
    </div>
  </app-scroll-view>

  <div class="actions-bottom">
    <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
      <app-button
        type="submit"
        buttonType="primary"
        styleType="contained"
        text="Pesquisar"
        width="20rem"
        [disabled]="formGroup.invalid"
      ></app-button>
    </div>
  </div>
</form>
